<div class="container">
  <div class="text" [innerHtml]="message"></div>
  <mat-icon (click)="close()">close</mat-icon>
</div>
